var _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPlayCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M516.476 2.488c269.305 0 487.619 218.314 487.619 487.619s-218.314 487.619-487.619 487.619c-269.305 0-487.619-218.314-487.619-487.619s218.314-487.619 487.619-487.619z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M841.538 490.111c0 86.216-34.245 168.901-95.212 229.864-60.962 60.967-143.648 95.212-229.864 95.212-86.218 0-168.903-34.245-229.867-95.212-60.965-60.962-95.214-143.648-95.214-229.864 0-86.218 34.249-168.903 95.214-229.868s143.649-95.213 229.867-95.213c86.216 0 168.901 34.249 229.864 95.213 60.967 60.964 95.212 143.65 95.212 229.868zM467.292 371.984c-3.038-2.163-6.613-3.448-10.333-3.715s-7.442 0.496-10.757 2.204c-3.315 1.708-6.096 4.295-8.039 7.479s-2.971 6.84-2.974 10.57v203.175c0.002 3.73 1.031 7.387 2.974 10.572s4.724 5.769 8.039 7.475c3.315 1.712 7.037 2.472 10.757 2.204 3.72-0.263 7.294-1.551 10.333-3.711l142.222-101.591c2.633-1.877 4.779-4.359 6.261-7.236s2.253-6.066 2.253-9.299c0-3.237-0.77-6.426-2.253-9.303s-3.628-5.358-6.261-7.237l-142.222-101.587z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlayCircle);
export default __webpack_public_path__ + "static/media/icon-play-circle.ff2d96303406ed75d6d984aee800c9ad.svg";
export { ForwardRef as ReactComponent };